import React from 'react';
import { Box } from '@chakra-ui/react';
import PageTitle from '../components/PageTitle';
import UpgradeShop from '../components/UpgradeShop';
import { useTeamRoster } from '../hooks/useTeamRoster';
import { useTeam } from '../hooks/useTeam';
import { useUserContext } from '../contexts/UserContext';
import { Team } from '../store/myLeagueStore';
import ErrorBoundary from '../components/ErrorBoundary';

const StorePageContent: React.FC = () => {
  const { myTeam } = useUserContext();
  const teamIdNumber = myTeam ? Number(myTeam) : undefined;
  
  const { total_payroll, loading: rosterLoading } = useTeamRoster(teamIdNumber || 1);
  const { team: teamData } = useTeam(teamIdNumber);
  const team = teamData as Team | null;

  return (
    <Box className="minimal-panel-padding">
      <PageTitle>Store</PageTitle>
      <UpgradeShop
        rosterLoading={rosterLoading}
        totalPayroll={total_payroll}
        team={team}
      />
    </Box>
  );
};

const StorePage: React.FC = () => {
  return (
    <ErrorBoundary>
      <StorePageContent />
    </ErrorBoundary>
  );
};

export default StorePage;

